const URL_SCHEME_BLACKLIST = ['javascript:', 'data:', 'vbscript:'] as const
const URL_SCHEME_ALLOWLIST = ['http://', 'https://', 'mailto:', 'tel:'] as const
const URL_RELATIVE_PREFIX_ALLOWLIST = ['/', '#', '?', './', '../'] as const

export function sanitizeUrlForNavigation(url: string | undefined): string | undefined {
  const raw = url?.trim()
  if (!raw) return undefined

  const lower = raw.toLowerCase()
  if (URL_SCHEME_BLACKLIST.some((scheme) => lower.startsWith(scheme))) {
    return undefined
  }

  if (URL_SCHEME_ALLOWLIST.some((scheme) => lower.startsWith(scheme))) {
    return raw
  }

  if (URL_RELATIVE_PREFIX_ALLOWLIST.some((prefix) => raw.startsWith(prefix))) {
    return raw
  }

  return undefined
}
